// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "provider-performancefunnel{position:relative;top:0;left:0;right:0;display:block;height:100%}provider-performancefunnel d3-funnel{height:90%;width:80%;min-width:800px;min-height:900px;display:block;margin:auto}\n", ""]);
// Exports
module.exports = exports;
